import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { service } from 'services';
import { withRouter } from 'react-router-dom';
import DirectionArrow from './direction-arrow';

export default withRouter(({ item = {}, match }) => {
  const { dcId, serverId, id: _serverId } = match?.params;
  const {
    id, name = '', dhcp = true, ips = [], firewallActive = false, firewallType = 'INGRESS', nat = false, lan = '',
  } = item;
  const model = {
    name, dhcp, ips, firewallActive, firewallType, nat, lan,
  };

  const fields = [
    {
      name: 'name',
      type: 'text',
      title: 'Name',
      placeholder: 'Name is optional',
    },
    {
      name: 'lan',
      type: 'lan',
      title: 'LAN',
    },
    {
      name: 'ips',
      type: 'ips',
      title: 'Select IPs',
    },
    {
      name: 'dhcp',
      type: 'switch',
      title: 'DHCP',
    },
    {
      name: 'nat',
      type: 'switch',
      title: 'NAT',
    },
    {
      name: 'firewallActive',
      type: 'switch',
      title: 'Firewall',
    },
    {
      name: 'firewallType',
      type: 'dropdown',
      values: [
        ['INGRESS', <DirectionArrow type="INGRESS" />],
        ['EGRESS', <DirectionArrow type="EGRESS" />],
        ['BIDIRECTIONAL', <DirectionArrow type="BIDIRECTIONAL" />],
      ],
      title: 'Firewall Direction',
      visible: false,
    },
  ];

  // eslint-disable-next-line no-shadow
  const onSave = async ({ lan, ...properties }) => {
    if (lan === 'new') {
      const lanResponse = await service.lan.create({
        properties: { name: properties.name || '', public: false },
        dcId,
      });
      lan = lanResponse.id;
    }

    if (lan) properties.lan = lan;

    if (id) {
      actions.nic.update({
        dcId, nicId: id, properties, serverId,
      });
    } else {
      actions.nic.create({ dcId, properties, serverId: _serverId });
    }
  };

  return (
    <>
      <Shared.forms.Form
        fields={fields}
        fieldsValues={model}
        onSubmit={onSave}
        isCancel={false}
        changeFields={[{
          name: 'firewallType',
          props: {
            visible: firewallActive,
          },
        }]}
      />
    </>
  );
});
